import { useTranslation } from 'next-i18next';
import { Dispatch, SetStateAction } from 'react';
import { useFormContext } from 'react-hook-form';

import { IWarehouseManagement } from '@/modules/warehouseManagement/shared/types';
import { useCreateInboundDeliveryUtils } from '@/modules/warehouseManagement/warehouses/components/InboundDelivery/CreateEditInboundDelivery/logic';
import { Table } from '@/shared/components/atoms';
import IconWithTitleDescription from '@/shared/components/atoms/IconWithTItleDescription';
import ReviewCard from '@/shared/components/molecules/MultiStepForm/ReviewCard';

const Review: React.FC<{ setStep: Dispatch<SetStateAction<number>> }> = ({
  setStep,
}) => {
  const { t } = useTranslation();

  const { watch } =
    useFormContext<IWarehouseManagement.ICreateInboundDeliveryFormValues>();

  const { products, ...restForm } = watch();

  const { getReviewGeneralCardItems, getReviewInputsTable } =
    useCreateInboundDeliveryUtils();

  return (
    <div className='flex flex-col gap-32'>
      <ReviewCard header={t('general-information')} onClick={() => setStep(0)}>
        {getReviewGeneralCardItems(restForm).map((props) => (
          <IconWithTitleDescription key={props.title} item={props} />
        ))}
      </ReviewCard>
      <ReviewCard
        header={t('Inputs')}
        onClick={() => setStep(1)}
        py='0'
        px='0'
        cols='grid-cols-1'
      >
        <Table<IWarehouseManagement.IInboundDeliveryFormProduct>
          pagination={false}
          selection={false}
          data={products}
          columns={getReviewInputsTable()}
          footerClassName='bg-neutralVariant-95'
          headCellClassName='text-start border-b-xs border-neutralVariant-90 text-surface-10 font-semi-bold'
          rowCellClassName='border-b-xs border-neutralVariant-90'
          headContainerClassName='!bg-background-neutral-99'
          tableWrapperClassName='!rounded-xl'
        />
      </ReviewCard>
    </div>
  );
};

export default Review;
